module.exports = __webpack_public_path__ + "img/cerc.7c97f2c9.jpg";